<div class="actionwrapper">
    <div class="actions">
        <button mat-raised-button color="primary" [disabled]="!isEditorDataReady" (click)="addItem()">
            <mat-icon>add</mat-icon>
            Add new admin fee
        </button>
    </div>
</div>
<table class="table" mat-table matSort [dataSource]="items">
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Brand</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.name || item.vendorId}}</td>
  </ng-container>
  <ng-container matColumnDef="amountCents">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Admin fee amount (cents)</th>
    <td class="cell" mat-cell *matCellDef="let item">{{item.amountCents}}</td>
  </ng-container>
  <ng-container matColumnDef="scope">
    <th mat-header-cell *matHeaderCellDef>Scope</th>
    <td class="cell" mat-cell *matCellDef="let item">{{getScope(item)}}</td>
  </ng-container>
  <ng-container matColumnDef="cartLabel">
    <th mat-header-cell *matHeaderCellDef>Cart label</th>
    <td class="cell" mat-cell *matCellDef="let item">{{getCartLabel(item)}}</td>
  </ng-container>
  <ng-container matColumnDef="actionmenu" stickyEnd>
    <th mat-header-cell matTooltip="Actions" *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let item"><button mat-button class="cell" [matMenuTriggerFor]="menu" [matMenuTriggerData]="{item: item}"><mat-icon matTooltip="Actions" class="more">more_vert</mat-icon></button></td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="allColumnNames"></tr>
  <tr class="listitem" mat-row *matRowDef="let rows; columns: allColumnNames"></tr>
  <mat-menu #menu="matMenu">
    <ng-template matMenuContent let-item="item">
      <button mat-menu-item (click)="editItem(item)">Edit</button>
      <button mat-menu-item (click)="duplicateItem(item)">Duplicate</button>
      <button mat-menu-item (click)="deleteItem(item)">Remove</button>
    </ng-template>
  </mat-menu>
</table>
